/**
 * A transport protocol version between the app and the webui.
 * It shows a warning in handshaking stage if the version is different between the app and the webui.
 * The value should be increased when the protocol is changed.
 */
export const PROTOCOL_VERSION = 1;
